import { Container } from "./styled"


const Header = () => {
  return (
    <Container>Header</Container>
  )
}

export default Header